<template>
  <div>
    <div class="top-bg">
      <!--头部开始 -->
      <top-part></top-part>
      <!-- 头部结束 -->
      <!-- 头部导航开始 -->
      <div class="top-nav">
        <van-tabs
          v-model="activeName"
          background="#29BEBC"
          color="#fff"
          line-height="2px"
          line-width="28px"
          @change="changeTab"
          :border="false"
        >
          <van-tab
            title-style="color: #fff"
            v-for="(item,index) of tabList"
            :key="index"
            :title="item.title"
            :name="item.name"
            height="100%"
          >
            <div class="bg-box"></div>
            <!--内容部分开始 -->
            <div class="center-div">
              <div class="list-div list-div1">
                <div class="item-flex">
                  <span class="rank-span">
                    <i
                      class="rank-i"
                      style="font-weight: bold"
                    >{{personalRank.rank === 0?'--':personalRank.rank}}</i>
                  </span>
                  <div>
                    <img
                      class="header-img"
                      :src="centralControl.utils.chargeHeaderImg(personalRank,'photo')"
                    />
                    <i class="des-text">{{personalRank.staffName}}</i>
                  </div>
                </div>
                <div class="item-flex1">
                  <i class="color-other">{{personalRank.stepCount}}</i>
                </div>
              </div>
              <van-pull-refresh v-if="!noDate" v-model="refreshing" @refresh="onRefresh">
                <van-list
                  v-model="loading"
                  :finished="finished"
                  finished-text="没有更多了"
                  @load="onLoad"
                >
                  <div class="list-div" v-for="(item,index) in list" :key="index">
                    <div class="item-flex">
                      <span class="rank-span">
                        <img class="rank-icon" v-if="item.imgUrl" :src="item.imgUrl" />
                        <i class="rank-i" :style="[{'color':item.color}]">{{item.rank}}</i>
                      </span>
                      <div>
                        <img class="header-img" :src="chargeImg(item)" />
                        <i class="des-text">{{item.staffName}}</i>
                      </div>
                    </div>
                    <div class="item-flex1">
                      <i :class="item.imgUrl?'color-i':'color-other'">{{item.stepCount}}</i>
                    </div>
                  </div>
                </van-list>
              </van-pull-refresh>
            </div>
            <!--内容部分结束 -->
          </van-tab>
        </van-tabs>
      </div>
      <!-- 头部导航结束 -->

      <div class="content-box">
        <div v-if="noDate">
          <van-empty
            class="custom-image"
            :image="require('../../assets/images/null@2x.png')"
            description="暂无数据"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import moment from "moment";
import topPart from "../../components/topPart";
import { toast } from "@/common/api/api.js";
export default {
  components: {
    topPart
  },
  data() {
    return {
      activeName: "day",
      tabList: [
        { title: "日", name: "day" },
        { title: "周", name: "week" },
        { title: "月", name: "month" },
        { title: "总", name: "all" }
      ],
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      pageSize: 20,
      dataFinish: "",
      noDate: false,
      secondNum: true, //防止快速二次重复请求
      rankImg: {
        "0": {
          imgUrl: require("../../assets/images/first.png"),
          color: "#F7B731",
          rank: 1
        },
        "1": {
          imgUrl: require("../../assets/images/second.png"),
          color: "#A7B6C9",
          rank: 2
        },
        "2": {
          imgUrl: require("../../assets/images/third.png"),
          color: "#D46000",
          rank: 3
        }
      },
      personalRank: {} //个人排名信息
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    // 在切换tab之前的函数处理
    beforeChange() {},
    // 改变tab
    changeTab(name) {
      this.list = [];
      this.finished = false;
      this.noDate = false;
      this.page = 1;
      this.activeName = name;
      this.onLoad();
    },
    //对个人排名信息的处理 如果有自己头像就显示自己的，如果没有就根据性别显示默认头像
    chargeImg(dataImg) {
      return dataImg.photo !== ""
        ? dataImg.photo
        : dataImg.sex === "2"
        ? require("../../assets/images/doctor.png")
        : require("../../assets/images/male_img.png");
    },

    // 给123名添加图标图片
    addImg(data) {
      // if (this.list.length < 3) {
      for (let index in data) {
        if (index >= 3) {
          return;
        }
        if (data[index].rank == this.rankImg[index].rank) {
          var objAttr = this.rankImg[index];
          data[index] = Object.assign(data[index], objAttr);
        }
      }
      // }
    },
    // 根据数组中的rank排序
    attrSort(rank) {
      return function(a, b) {
        return parseInt(a[rank]) - parseInt(b[rank]);
      };
    },
    // 获取步数
    getStep() {
      let that = this;
      // 防止二次点击
      if (this.secondNum == false) {
        return;
      }
      var activeNameFlag = that.activeName;
      this.flagReturn = false;
      this.centralControl.axios.centralControl(
        "staffRankByType",
        res => {
          if (res.code == 200) {
            if (activeNameFlag == that.activeName) {
              if (res.data.allRank.length == 0 && that.list.length == 0) {
                that.noDate = true;
                this.list = [];
                this.finished = true;
              } else {
                this.finished = false;
                that.noDate = false;
              }
              that.personalRank = res.data.personRank;
              console.log(that.personalRank);
              if (that.page > res.data.totalPage) {
                that.finished = true;
                // return;
                // that.refreshing = false;
              }
              // if (that.page == 1) {
              //   that.list = [];
              // }
              that.secondNum == true;
              // console.log(res.data.allRank, "----");
              that.list = [...that.list, ...res.data.allRank];
              that.list = that.list.sort(this.attrSort("rank"));
              that.addImg(that.list);
              console.log(that.list);

              // if (that.page >= res.data.totalPage) {
              //   that.finished = true;
              //   // that.refreshing = false;
              // }
              that.loading = false;
              // that.page++;
            }
          } else {
            that.loading = true;
            that.finished = true;
            that.noDate = true;
            toast(that, res.message, "error");
          }
        },
        {
          type: that.activeName,
          currentPage: that.page,
          pageSize: that.pageSize
        }
      );
    },
    init() {},
    onLoad() {
      // if (this.refreshing) {
      //   this.list = [];
      //   this.refreshing = false;
      // }
      // this.getStep();

      let timer = setTimeout(() => {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }
        this.getStep();
        this.page++;
        this.finished && clearTimeout(timer);
      }, 100);
    },
    onRefresh() {
      // 重置page
      this.page = 1;
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../assets/stylus/common.styl';

.top-nav {
  position: fixed;
  top: 38px;
  width: 100%;
  z-index: 999;
  bottom: 0;
}

.van-tabs {
  height: 100%;
}

.van-tabs__content {
  height: 100%;
}

// .bg-box1 {
// height: 10px;
// border-radius:8px 8px 0px 0px;
// background: #fff;
// }
.van-tab__pane {
  height: 100%;
}

.van-pull-refresh {
  height: 430px;
  overflow: scroll;
}

.bg-box {
  height: 20px;
  background: #29BEBC;
}

.rank-icon {
  width: 16px;
  height: 12px;
  position: absolute;
  left: 10px;
  top: 0;
  bottom: 0;
  margin: auto;
}

.top-box {
  color: #fff;
  background: rgb(41, 190, 188);
  box-shadow: none;
}

.content-box {
  myContent();
  top: 140px;
  background: #fff;
}

.list-div {
  display: flex;
  padding: 10px;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0.5px 0px 0px rgba(212, 218, 235, 0.5);
}

.center-div {
  background: rgba(248, 252, 255, 1);
  border-radius: 8px 8px 0px 0px;
  height: 100%;
  margin-top: -10px;
}

.list-div1 {
  box-shadow: 0px 3px 6px 0px rgba(212, 218, 235, 0.5);
}

.item-flex {
  flex: 2;
  display: flex;
}

.item-flex1 {
  flex: 1;
  text-align: center;
}

.rank-span {
  width: 76px;
  display: inline-block;
  text-align: center;
  position: relative;
  height: 20px;
  font-size: 16px;
  font-family: DIN-Regular, DIN;
  font-weight: 400;
  color: rgba(53, 53, 53, 1);
  // line-height: 20px;
  margin: auto;
}

.rank-i {
  height: 19px;
  font-size: 16px;
  font-family: DIN-Bold, DIN;
  font-weight: 400;
  color: rgba(53, 53, 53, 1);
  line-height: 19px;
  display: inline-block;
  vertical-align: middle;
}

.header-img {
  width: 42px;
  height: 42px;
  border-radius: 50px;
  border: 1px solid rgba(229, 229, 229, 1);
  margin-right: 10px;
}

.des-text {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(53, 53, 53, 1);
  display: inline-block;
  width: 100px;
  ellipsis();
  vertical-align: middle;
}

.color-i {
  height: 29px;
  font-size: 24px;
  font-family: DIN-Medium, DIN;
  font-weight: 500;
  color: rgba(247, 183, 49, 1);
  line-height: 29px;
}

.color-other {
  height: 29px;
  font-size: 20px;
  font-family: DIN-Medium, DIN;
  font-weight: 500;
  color: rgba(53, 53, 53, 1);
  line-height: 29px;
}
</style>